import { render, staticRenderFns } from "./waterVolumnManage.vue?vue&type=template&id=350f6db1"
import script from "./waterVolumnManage.vue?vue&type=script&lang=js"
export * from "./waterVolumnManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350f6db1')) {
      api.createRecord('350f6db1', component.options)
    } else {
      api.reload('350f6db1', component.options)
    }
    module.hot.accept("./waterVolumnManage.vue?vue&type=template&id=350f6db1", function () {
      api.rerender('350f6db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/waterVolumnManage.vue"
export default component.exports